import Version from './version';

export enum Keys {
  ACCOUNT_SETTINGS = 'RBI::ACCOUNT_SETTINGS',
  APP_RATING_SHOWN = 'RBI::APP_RATING_SHOWN',
  APPLIED_LOYALTY_OFFERS = 'RBI::APPLIED_LOYALTY_OFFERS',
  APPLIED_LOYALTY_REWARDS = 'RBI::APPLIED_LOYALTY_REWARDS',
  AUTH_REDIRECT = 'RBI::AUTH_REDIRECT',
  BRAND = 'RBI::BRAND',
  DELIVERY_SURCHARGE_FEE = 'RBI::DELIVERY_SURCHARGE_FEE',
  DELIVERY_ADDRESS = 'RBI::DELIVERY_ADDRESS',
  DETERMINING_LOCALE_COMPLETE = 'RBI::DETERMINING_LOCALE_COMPLETE',
  DISABLE_CHICKEN_SANDWICH = 'RBI::DISABLE_CHICKEN_SANDWICH',
  FIRST_DATA = 'RBI::FIRST_DATA',
  GEO_PERMISSION = 'RBI::GEO_PERMISSION',
  HAS_DONE_FIRST_APP_LOAD_ONBOARDING = 'RBI::HAS_DONE_FIRST_APP_LOAD_ONBOARDING',
  HAS_SHOWN_LOCALE_SELECTOR = 'RBI::HAS_SHOWN_LOCALE_SELECTOR',
  HOSTNAME = 'RBI::HOSTNAME',
  IN_RESTAURANT_CART_LAST_UPDATE = 'RBI::IN_RESTAURANT_CART_LAST_UPDATE',
  IN_RESTAURANT_REDEMPTION = 'RBI::LOYALTY_IN_RESTAURANT_REDEMPTION',
  IN_RESTAURANT_REDEMPTION_LAST_MOD = 'RBI::IN_RESTAURANT_REDEMPTION_LAST_MOD',
  IN_RESTAURANT_REDEMPTION_SHORT_CODE = 'RBI::LOYALTY_IN_RESTAURANT_REDEMPTION_SHORT_CODE',
  LANGUAGE = 'RBI::LANGUAGE',
  LAST_COOKIE_VERSION = 'RBI::COOKIE_VERSION',
  LAST_TIME_COOKIES_ACCEPTED = 'RBI::LAST_TIME_COOKIES_ACCEPTED',
  LAST_TIME_COOKIES_IGNORED = 'RBI::LAST_TIME_COOKIES_IGNORED',
  LAST_TIME_STORE_UPDATED = 'RBI::LAST_TIME_STORE_UPDATED',
  LAUNCH_DARKLY_USER_ATTRIBUTES = 'RBI::LAUNCH_DARKLY_USER_ATTRIBUTES',
  LOGIN = 'RBI::LOGIN',
  LOYALTY_CARD = 'RBI::LOYALTY',
  OFFER = 'RBI::OFFER',
  OFFER_REDEMPTION = 'RBI::OFFER_REDEMPTION',
  OFFERS_REDEEMED_NO_AUTH = 'RBI::OFFERS_REDEEMED_NO_AUTH',
  ONETRUST_COOKIE_CONSENT_GROUPS = 'RBI::ONETRUST_COOKIE_CONSENT_GROUPS',
  ORDER = 'RBI::ORDER',
  ORDER_LAST_UPDATE = 'RBI::ORDER_LAST_UPDATE',
  OTP = 'RBI::OTP',
  PAYBACK_TOKEN = 'RBI::PAYBACK_TOKEN',
  PAYMENT = 'RBI::PAYMENT',
  QUIZ_ANSWERS = 'RBI::QUIZ_ANSWERS',
  QUIZ_RESULTS = 'RBI::QUIZ_RESULTS',
  QUOTE_ID = 'RBI::QUOTE_ID',
  REDEEM_LAST_CODE_STATE = 'RBI::REDEEM_LAST_CODE_STATE',
  REDEEM_SHOULD_REFRESH = 'RBI::REDEEM_SHOULD_REFRESH',
  REGION = 'RBI::REGION',
  REGION_REDIRECT = 'RBI::REGION_REDIRECT',
  SELECTED_LOYALTY_OFFER = 'RBI::SELECTED_LOYALTY_OFFER',
  SERVICE_MODE = 'RBI::SERVICE_MODE',
  STORAGE_VERSION = 'RBI::STORAGE_VERSION',
  STORE = 'RBI::STORE',
  STORE_NUMBER_PRESET = 'RBI::STORE_PRESET',
  TABBED_MENU_PREVIOUS_ACTIVE_TAB = 'RBI::TABBED_MENU_PREVIOUS_ACTIVE_TAB',
  TABLE_NUMBER = 'RBI::TABLE_NUMBER',
  TIMCARD = 'RBI::TIMCARD',
  USER = 'RBI::USER',
  USER_SIGNED_IN_SUCCESSFULLY = 'RBI::USER_SIGNED_IN_SUCCESSFULLY',
  VEHICLE_DESCRIPTION = 'RBI::VEHICLE_DESCRIPTION',
}

export const APP_KEY_PREFIX = 'RBI::';

export const LOCAL_STORAGE_VERSION = Version.localStorage;
export const COOKIE_VERSION = Version.cookie;
